import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/24/outline';
import { useCallback } from 'react';
import { SelectItemContent } from '../../../components/selects/SelectItem';
import { useGroupOperations } from '../../../hooks/potree/useGroupOperations';
import { T } from '../../../translation/src';

export const useUpdatePosition = ({
  annotationIdentifier,
  groupIdentifier,
  parentGroupIdentifier,
  downDisabled,
  upDisabled,
}: {
  annotationIdentifier?: string;
  groupIdentifier?: string;
  parentGroupIdentifier?: string;
  downDisabled?: boolean;
  upDisabled?: boolean;
}) => {
  const { updateOrdering } = useGroupOperations();

  const UpdatePositionItems = useCallback(
    ({ index }: { index: number }) => {
      const identifier = annotationIdentifier || groupIdentifier || '';
      const type = annotationIdentifier ? 'annotation' : 'group';
      const onMoveUp = () =>
        updateOrdering({
          identifiers: [{ identifier, type }],
          toIndex: index - 1,
          toGroupIdentifier: parentGroupIdentifier,
        });
      const onMoveDown = () =>
        updateOrdering({
          identifiers: [{ identifier, type }],
          toIndex: index + 1,
          toGroupIdentifier: parentGroupIdentifier,
        });
      return (
        <>
          <SelectItemContent icon={ArrowUpIcon} onClick={onMoveUp} disabled={upDisabled}>
            <T _str="move up" swc />
          </SelectItemContent>
          <SelectItemContent icon={ArrowDownIcon} onClick={onMoveDown} disabled={downDisabled}>
            <T _str="move down" swc />
          </SelectItemContent>
        </>
      );
    },
    [annotationIdentifier, downDisabled, updateOrdering, groupIdentifier, parentGroupIdentifier, upDisabled],
  );

  return [{ UpdatePositionItems }];
};
